import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Modal, Typography } from "antd";
import { useState } from "react";
import AddFavoriteList from "./AddFavoriteList";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "apps/RealState/Details/ServerSideStates";
import { deleteFavoriteAdvert } from "apps/CustomerPanel/Favorite/Pages/Ads/Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";

const FavoriteButton = () => {
  const { Text } = Typography;
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const [isShowAddToFavoriteModal, setIsShowAddToFavoriteModal] =
    useState(false);
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(advertId);
  const data = advertDetails?.data?.data;
  const handleDeleteAdvertFavoriteList = async () => {
    try {
      await deleteFavoriteAdvert(data);
      openNotificationWithIcon("default", "İlan başarıyla listeden kaldırıldı");
      advertDetails.refetch();
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.error("Favori kaldırma işleminde hata oluştu", error);
    }
  };

  return (
    <>
      <span
        className="hover:cursor-pointer !flex gap-1 !p-2 !rounded-md transition"
        onClick={() => {
          if(userInfoes)
          {
            if(data.isFavorite)
            {
              handleDeleteAdvertFavoriteList()
            }
            else{
  
              setIsShowAddToFavoriteModal(true);
            }

          }
          else{
            openNotificationWithIcon("default","İlanı favoriye eklemek için giriş yapınız")
          }
        }}
      >
        {data?.isFavorite ? (
          <>
            <HeartFilled  className="!text-sm !text-red-500" />
            <Text className="!text-xs">Favoriden Kaldır</Text>
          </>
        ) : (
          <>
            <HeartOutlined className="!text-sm !text-red-500" />
            <Text className="!text-xs">Favorilere Ekle</Text>
          </>
        )}
      </span>
      <Modal
        open={isShowAddToFavoriteModal}
        onCancel={() => {
          setIsShowAddToFavoriteModal(false);
        }}
        footer={false}
        title={"İlanı Favoriye Ekle"}
      >
        <AddFavoriteList selectedRecord={data} onFinish={()=>{
          setIsShowAddToFavoriteModal(false);
          advertDetails.refetch()
        }}  />
      </Modal>
    </>
  );
};

export default FavoriteButton;
